import { render, staticRenderFns } from "./LegacyProjectBanner.vue?vue&type=template&id=20fe050c"
import script from "./LegacyProjectBanner.vue?vue&type=script&lang=js"
export * from "./LegacyProjectBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports